import { AppRoutesNavigation } from '../app-routes'
import { AppFeatureIntegration } from '../constants/appFeatureIntegrations'
import { ReactComponent as LocalityIcon } from '../assets/icons/localityIcon.svg'
import { ReactComponent as ServiceStation } from '../assets/icons/serviceStationIcon.svg'
import { ReactComponent as ProjectIcon } from '../assets/icons/projectIcon.svg'
import { ReactComponent as storageIcon } from '../assets/icons/storageIcon.svg'
import { ReactComponent as vesselIcon } from '../assets/icons/vesselIcon.svg'

export const mainTopBarItems = [
  {
    name: 'projects',
    main: AppRoutesNavigation.Project.basePath,
    path: AppRoutesNavigation.Project.main,
    Icon: ProjectIcon,
    access: 'hasProjectPlanningAccess',
    integrationKey: AppFeatureIntegration.PortalMainProjectManagement,
  },
  {
    name: 'localities',
    main: AppRoutesNavigation.Localities.basePath,
    path: AppRoutesNavigation.Localities.main,
    Icon: LocalityIcon,
    access: 'hasLocalityAccess',
  },
  {
    name: 'service-stations',
    main: AppRoutesNavigation.serviceStation.basePath,
    path: AppRoutesNavigation.serviceStation.main,
    Icon: ServiceStation,
    access: 'hasServiceStationAccess',
  },
  {
    name: 'storage',
    main: AppRoutesNavigation.storage.basePath,
    path: AppRoutesNavigation.storage.main,
    Icon: storageIcon,
    access: 'hasStorageAccess',
  },
  { name: 'vessels', path: AppRoutesNavigation.Vessel, Icon: vesselIcon },
]
